const PRODUCT_TILE = [164, 230];
const THUMBNAIL_PRODUCT_MEDIA_ITEM = 48;

module.exports = {
    PRODUCT_TILE,
    THUMBNAIL_PRODUCT_MEDIA_ITEM
};
